<template>
  <div id="myChild" :class="checkMobileStatus ? 'mobile-myChild' : ''">
    <div class="datatable-edit__header">
      <div class="container">
        <i class="fa fa-long-arrow-left fa-2x mobile-back" aria-hidden="true" v-if="checkMobileStatus" @click="backPrevious()"></i>
        <h4>{{ lang('Child Details') }}</h4>
      </div>
    </div>
    <div class="profilePictureArea form-group">
      <div class="container">
        <div class="profile_wrap">
          <img v-bind:src="imgStudentProfile" type="file" @click="uploadStudentProfileImg()" class="imgStudentProfile" />
          <span>{{ inputStudentFirstName }}</span>
          <small class="parent_wrap" @click="backPrevious()" v-if="!checkMobileStatus">{{ lang('Back') }}</small>
        </div>
      </div>
      <input type="file" ref="file" accept="image/*" style="display: none" @change="previewImgStudentProfile" />
    </div>

    <div class="mt-3 container">
      <div class="mobile-studentPageBTabs" :style="[checkMobileStatus ? { display: 'block' } : { display: 'none' }]">
        <el-collapse>
          <el-collapse-item class="mobile-collapse-container" name="1">
            <template slot="title">
              <i class="fa fa-user common-icon"></i><span class="common-text">{{ lang('Student') }}</span>
            </template>

            <div class="form-group">
              <div class="studentAreaDiv">
                <div class="">
                  <h5 class="text-left student-form__title">{{ lang('Children Information') }}</h5>
                </div>
                <div class="row form-group__wrapper">
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('First Name') }}</label>
                    <input type="text" class="form-control form__input" v-model="inputStudentFirstName" readonly="readonly" />
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Middle Name') }}</label>
                    <input type="text" class="form-control" v-model="inputStudentMiddleName" readonly="readonly" />
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Last Name') }}</label>
                    <input type="text" class="form-control" v-model="inputStudentLastName" readonly="readonly" />
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Preferred Name') }}</label>
                    <input type="text" class="form-control" v-model="inputStudentPreferredName" />
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Nationality') }}</label>
                    <input type="text" class="form-control" v-model="ddlStudentNationality" readonly="readonly" />
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Gender') }}</label>
                    <input type="text" class="form-control" v-model="ddlStudentGender" readonly="readonly" />
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Date of Birth') }}</label>
                    <div class="date">
                      <input type="text" class="form-control" v-model="inputStudentDateOfBirth" readonly="readonly" />
                    </div>
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Birth Place') }}</label>
                    <input type="text" class="form-control" v-model="ddlStudentBirthPlace" readonly="readonly" />
                  </div>

                  <div v-if="finShowHide" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Fin') }}</label>
                    <input type="text" class="form-control" v-model="inputStudentIdentificationNo" />
                  </div>

                  <div v-if="finShowHide" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Fin Expiry Date') }}</label>
                    <div class="date">
                      <el-date-picker
                        v-model="inputStudentIdentificationExpiryDate"
                        format="dd/MM/yyyy"
                        value-format="dd/MM/yyyy"
                        type="date"
                        :placeholder="lang('Pick a day')"
                      ></el-date-picker>
                    </div>
                  </div>

                  <div v-if="birthcertShowHide" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Birth Certificate') }}</label>
                    <input type="text" class="form-control" v-model="inputStudentBirthCertificate" readonly="readonly" />
                  </div>

                  <div v-if="icShowHide" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('IC') }}</label>
                    <input type="text" class="form-control" v-model="inputStudentIC" readonly="readonly" />
                  </div>

                  <div v-if="passportShowHide" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Passport') }}</label>
                    <input type="text" class="form-control" v-model="inputStudentPassport" />
                  </div>

                  <div v-if="passportShowHide" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Passport Expiry Date') }}</label>
                    <div class="date">
                      <el-date-picker
                        v-model="inputStudentPassportExpiryDate"
                        format="dd/MM/yyyy"
                        value-format="dd/MM/yyyy"
                        type="date"
                        :placeholder="lang('Pick a day')"
                      ></el-date-picker>
                    </div>
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Other Identification') }}</label>
                    <input type="text" class="form-control" v-model="inputStudentOtherIdentification" />
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Religion') }}</label>
                    <select v-model="ddlStudentReligion" class="form-control pro-edt-select form-control-primary">
                      <!--<option v-for="item in ddlStudentReligionList" v-bind:value="{ id: item.OPTvalue.trim(), text: item.OPTvalue.trim() }">{{ item.OPTvalue.trim() }}</option>-->
                      <option v-for="item in ddlStudentReligionList" v-bind:value="item.OPTvalue.trim()">
                        {{ lang(item.OPTvalue.trim()) }}
                      </option>
                    </select>
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Additional Language') }}</label>
                    <select v-model="ddlStudentAdditionalLanguage" class="form-control pro-edt-select form-control-primary">
                      <option v-for="item in ddlStudentAdditionalLanguageList" v-bind:value="item.OPTvalue.trim()">{{ lang(item.OPTvalue.trim()) }}</option>
                    </select>
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Meal Preferences') }}</label>
                    <select v-model="ddlStudentMealPreferences" class="form-control pro-edt-select form-control-primary">
                      <option v-for="item in ddlStudentMealPreferencesList" v-bind:value="item.OPTvalue.trim()">{{ lang(item.OPTvalue.trim()) }}</option>
                    </select>
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Dietary Requirement') }}</label>
                    <input type="text" class="form-control" v-model="inputStudentDietaryRequirement" />
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('First Language Spoken') }}</label>
                    <input type="text" class="form-control" v-model="inputStudentFirstLanguageSpoken" />
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Second Language Spoken') }}</label>
                    <input type="text" class="form-control" v-model="inputSecondLanguageSpoken" />
                  </div>

                  <!--                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">-->
                  <!--                                    <label>Payer</label>-->
                  <!--                                    <select v-model="ddlStudentPayer"-->
                  <!--                                    class="form-control pro-edt-select form-control-primary">-->
                  <!--                                    <option v-for="item in ddlStudentPayerList" v-bind:value="item.OPTvalue.trim()">-->
                  <!--                                    {{-->
                  <!--                                    item.OPTvalue.trim() }}-->
                  <!--                                    </option>-->
                  <!--                                    </select>-->
                  <!--                                </div>-->

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Student ID') }}</label>
                    <input type="text" class="form-control" v-model="inputStudentID" readonly="readonly" />
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" style="display: none">
                    <label>{{ lang('Membership') }}</label>
                    <select v-model="ddlStudentMembership" class="form-control pro-edt-select form-control-primary">
                      <option v-for="item in ddlStudentMembershipList" v-bind:value="item.OPTvalue.trim()">{{ item.OPTvalue.trim() }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="studentAreaDiv">
                <div class="">
                  <h5 class="text-left student-form__title">{{ lang("Children's Local Residential Address") }}</h5>
                </div>

                <div class="row form-group__wrapper">
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Country') }}</label>
                    <select v-model="ddlStudentLocalAddressCountry" class="form-control pro-edt-select form-control-primary">
                      <option v-for="item in countryList" v-bind:value="item.CNYname.trim()">{{ item.CNYname.trim() }}</option>
                    </select>
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>* {{ lang('Postal Code') }}</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="inputStudentLocalAddressPostalCode"
                      v-on:blur="GetOneMapAPI('inputStudentLocalAddressPostalCode')"
                      :class="{ requiredFields: $v.inputStudentLocalAddressPostalCode.$error }"
                    />
                    <div class="requiredFieldsMsg" v-if="$v.inputStudentLocalAddressPostalCode.$error">
                      {{ lang('Postal code required') }}
                    </div>
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>* {{ lang('Address 1') }}</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="inputStudentLocalAddress1"
                      :class="{ requiredFields: $v.inputStudentLocalAddress1.$error }"
                    />
                    <div class="requiredFieldsMsg" v-if="$v.inputStudentLocalAddress1.$error">
                      {{ lang('Address 1 required') }}
                    </div>
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Address 2') }}</label>
                    <input type="text" class="form-control" v-model="inputStudentLocalAddress2" />
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Address 3') }}</label>
                    <input type="text" class="form-control" v-model="inputStudentLocalAddress3" />
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('City') }}</label>
                    <input type="text" class="form-control" v-model="inputStudentLocalAddressCity" />
                  </div>
                </div>
              </div>
            </div>
          </el-collapse-item>

          <el-collapse-item class="mobile-collapse-container" name="2">
            <template slot="title">
              <i class="fa fa-phone common-icon"></i><span class="common-text">{{ lang('Contact') }}</span>
            </template>

            <div class="form-group">
              <div class="ecAreaDiv">
                <div class="">
                  <h5 class="text-left student-form__title">{{ lang('1st Emergency Contact') }}</h5>
                </div>
                <div class="row form-group__wrapper">
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Contact Person') }}</label>
                    <input type="text" class="form-control" v-model="inputStudent1stEmergencyContact" />
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Contact No') }}</label>
                    <input type="text" class="form-control" v-model="inputStudent1stEmergencyContactNo" />
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Contact Relation') }}</label>
                    <input type="text" class="form-control" v-model="inputStudent1stEmergencyContactRelation" />
                  </div>
                </div>
              </div>
              <div class="ecAreaDiv">
                <div class="">
                  <h5 class="text-left student-form__title">{{ lang('2nd Emergency Contact') }}</h5>
                </div>
                <div class="row form-group__wrapper">
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Contact Person') }}</label>
                    <input type="text" class="form-control" v-model="inputStudent2ndEmergencyContact" />
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Contact No') }}</label>
                    <input type="text" class="form-control" v-model="inputStudent2ndEmergencyContactNo" />
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Contact Relation') }}</label>
                    <input type="text" class="form-control" v-model="inputStudent2ndEmergencyContactRelation" />
                  </div>
                </div>
              </div>

              <!--                        Start Authorized Children Pickup-->
              <div class="ecAreaDiv" v-if="studentAuthorizedPickupListInt.length > 0">
                <div class="">
                  <h5 class="text-left student-form__title">{{ lang('Authorized Children Pickup') }}</h5>
                </div>

                <div class="row form-group__wrapper">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div>
                      <data-tables :data="studentAuthorizedPickupListInt">
                        <el-table-column
                          v-for="studentAuthorizedPickupListInfo in studentAuthorizedPickupList"
                          :prop="studentAuthorizedPickupListInfo.prop"
                          :label="studentAuthorizedPickupListInfo.label"
                          :key="studentAuthorizedPickupListInfo.prop"
                          sortable="custom"
                        >
                        </el-table-column>
                      </data-tables>
                    </div>
                  </div>

                  <!--                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">-->
                  <!--                                    <label>Name</label>-->
                  <!--                                    <input type="text" class="form-control" v-model="inputStudentContactAuthorizedPickupName">-->
                  <!--                                </div>-->
                  <!--                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">-->
                  <!--                                    <label>Contact No</label>-->
                  <!--                                    <input type="text" class="form-control" v-model="inputStudentContactAuthorizedPickupContactNo">-->
                  <!--                                </div>-->
                  <!--                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">-->
                  <!--                                    <label>Identify No</label>-->
                  <!--                                    <input type="text" class="form-control"-->
                  <!--                                           v-model="inputStudentContactAuthorizedPickupIdenNo">-->
                  <!--                                </div>-->
                  <!--                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">-->
                  <!--                                    <label>Relationship</label>-->
                  <!--                                    <input type="text" class="form-control"-->
                  <!--                                           v-model="inputStudentContactAuthorizedPickupRelationship">-->
                  <!--                                </div>-->
                </div>

                <!--                            <button class="btn btn-primary waves-effect waves-light m-r-10" v-on:click="addMedicationAllergiesList()">-->
                <!--                                Add-->
                <!--                            </button>-->
              </div>
              <!--                        End Authorized Children Pickup-->
            </div>
          </el-collapse-item>

          <el-collapse-item class="mobile-collapse-container" name="3">
            <template slot="title">
              <i class="fa fa-credit-card common-icon"></i><span class="common-text">{{ lang('Billing') }}</span>
            </template>

            <div class="form-group">
              <div class="billAreaDiv">
                <div class="">
                  <h5 class="text-left student-form__title">{{ lang('Billing Info') }}</h5>
                </div>

                <div class="row form-group__wrapper">
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>* {{ lang('Payer') }}</label>
                    <select v-model="ddlStudentBillingPayer" class="form-control pro-edt-select form-control-primary" disabled="disabled">
                      <!--                                        :disabled="(disFatherCompany && item.OPTvalue.trim() === 'Father Company' && divParent) || (disMotherCompany && item.OPTvalue.trim() === 'Mother Company') && divParent"-->
                      <option v-for="item in ddlStudentBillingPayerList" v-bind:value="item.OPTvalue.trim()">
                        {{ lang(item.OPTvalue.trim()) }}
                      </option>
                    </select>
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Frequent Payments') }}</label>
                    <select v-model="ddlStudentBillingFrequentPayments" class="form-control pro-edt-select form-control-primary" disabled="disabled">
                      <option v-for="item in ddlStudentBillingFrequentPaymentsList" v-bind:value="item">
                        {{ item }}
                      </option>
                    </select>
                  </div>

                  <div v-if="isIntPreSchool || isLocalSchool" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('CDA') }}</label>
                    <input type="text" class="form-control" v-model="inputStudentBillingCda" readonly="readonly" />
                  </div>

                  <div v-if="ddlStudentBillingSubsidyShow" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Subsidy') }}</label>
                    <el-select v-model="ddlStudentBillingSubsidy" multiple class="ddlStudentBillingSubsidy" disabled="disabled">
                      <el-option v-for="item in ddlStudentBillingSubsidyList" :key="item.OPTid.trim()" :label="item.OPTvalue.trim()" :value="item.OPTid.trim()">
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>

              <div class="billAreaDiv">
                <div class="">
                  <h5 class="text-left student-form__title">{{ lang('Billing Address') }}</h5>
                </div>

                <div class="row form-group__wrapper">
                  <!--                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">-->
                  <!--                                    <label>Copy Address From Student's Permanent Address</label>-->
                  <!--                                    <select v-model="ddlStudentBillingAddressType"-->
                  <!--                                            class="form-control pro-edt-select form-control-primary">-->
                  <!--                                        <option v-for="item in ddlStudentBillingAddressTypeList" v-bind:value="item">-->
                  <!--                                            {{item}}-->
                  <!--                                        </option>-->
                  <!--                                    </select>-->
                  <!--                                </div>-->

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Country') }}</label>
                    <select v-model="ddlStudentBillingAddressCountry" class="form-control pro-edt-select form-control-primary">
                      <option v-for="item in countryList" v-bind:value="item.CNYname.trim()">{{ item.CNYname.trim() }}</option>
                    </select>
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>* {{ lang('Postal Code') }}</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="inputStudentBillingAddressPostalCode"
                      v-on:blur="GetOneMapAPI('inputStudentBillingAddressPostalCode')"
                      :class="{ requiredFields: $v.inputStudentBillingAddressPostalCode.$error }"
                    />
                    <div class="requiredFieldsMsg" v-if="$v.inputStudentBillingAddressPostalCode.$error">
                      {{ lang('Postal code required') }}
                    </div>
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>* {{ lang('Address 1') }}</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="inputStudentBillingAddress1"
                      :class="{ requiredFields: $v.inputStudentBillingAddress1.$error }"
                    />
                    <div class="requiredFieldsMsg" v-if="$v.inputStudentBillingAddress1.$error">
                      {{ lang('Address 1 required') }}
                    </div>
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Address 2') }}</label>
                    <input type="text" class="form-control" v-model="inputStudentBillingAddress2" />
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Address 3') }}</label>
                    <input type="text" class="form-control" v-model="inputStudentBillingAddress3" />
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('City') }}</label>
                    <input type="text" class="form-control" v-model="inputStudentBillingAddressCity" />
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Mobile No') }}</label>
                    <input type="text" class="form-control" v-model="inputStudentBillingMobileNo" />
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Home Tel No') }}</label>
                    <input type="text" class="form-control" v-model="inputStudentBillingHomeTelNo" />
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>* {{ lang('Email') }}</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="inputStudentBillingEmail"
                      :class="{ requiredFields: $v.inputStudentBillingEmail.$error }"
                    />
                    <div class="requiredFieldsMsg" v-if="$v.inputStudentBillingEmail.$error">
                      {{ lang('Email required or Email invalid format') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-collapse-item>

          <el-collapse-item class="mobile-collapse-container" name="4">
            <template slot="title">
              <i class="fa fa-medkit common-icon"></i><span class="common-text">{{ lang('Medical') }}</span>
            </template>

            <div class="form-group">
              <div class="medAreaDiv">
                <div class="">
                  <h5 class="text-left student-form__title">{{ lang('Medication Allergies List') }}</h5>
                </div>

                <div>
                  <div v-if="medicationAllergiesListInt.length > 0">
                    <data-tables :data="medicationAllergiesListInt" :action-col="medicationAllergiesListAcion">
                      <el-table-column
                        v-for="medicationAllergiesListInfo in medicationAllergiesList"
                        :prop="medicationAllergiesListInfo.prop"
                        :label="medicationAllergiesListInfo.label"
                        :key="medicationAllergiesListInfo.prop"
                        sortable="custom"
                      >
                      </el-table-column>
                    </data-tables>
                  </div>
                </div>

                <div class="row form-group__wrapper">
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Medication') }}</label>
                    <input type="text" class="form-control" v-model="inputStudentMedicationAllergiesMedication" />
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Remarks') }}</label>
                    <input type="text" class="form-control" v-model="inputStudentMedicationAllergiesRemarks" />
                  </div>
                </div>

                <button class="btn btn-primary waves-effect waves-light m-r-10" v-on:click="addMedicationAllergiesList()">
                  {{ lang('Add') }}
                </button>
              </div>

              <div class="medAreaDiv">
                <div class="">
                  <h5 class="text-left student-form__title">{{ lang('Food Allergies List') }}</h5>
                </div>

                <div>
                  <div v-if="foodAllergiesListInt.length > 0">
                    <data-tables :data="foodAllergiesListInt" :action-col="foodAllergiesListAcion">
                      <el-table-column
                        v-for="foodAllergiesListInfo in foodAllergiesList"
                        :prop="foodAllergiesListInfo.prop"
                        :label="foodAllergiesListInfo.label"
                        :key="foodAllergiesListInfo.prop"
                        sortable="custom"
                      >
                      </el-table-column>
                    </data-tables>
                  </div>
                </div>

                <div class="row form-group__wrapper">
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Food') }}</label>
                    <select v-model="ddlStudentFoodAllergiesFood" class="form-control pro-edt-select form-control-primary">
                      <option v-for="item in ddlddlStudentFoodAllergiesFoodList" v-bind:value="item.OPTvalue.trim()">{{ item.OPTvalue.trim() }}</option>
                    </select>
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Remarks') }}</label>
                    <input type="text" class="form-control" v-model="inputStudentFoodAllergiesRemarks" />
                  </div>
                </div>

                <button class="btn btn-primary waves-effect waves-light m-r-10" v-on:click="addFoodAllergiesList()">
                  {{ lang('Add') }}
                </button>
              </div>

              <div class="medAreaDiv">
                <div class="">
                  <h5 class="text-left student-form__title">{{ lang("Student's Medical Details") }}</h5>
                </div>

                <div class="row form-group__wrapper">
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Major Ailments List') }}</label>
                    <textarea rows="3" class="textArea" v-model="taMajorAilmentsList"></textarea>
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Name of Family Doctor') }}</label>
                    <input type="text" class="form-control" v-model="inputNameofFamilyDoctor" />
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Clinic Address') }}</label>
                    <input type="text" class="form-control" v-model="inputClinicAddress" />
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>{{ lang('Clinic Phone No') }}</label>
                    <input type="text" class="form-control" v-model="inputClinicPhoneNo" />
                  </div>
                </div>
              </div>
            </div>
          </el-collapse-item>

          <el-collapse-item class="mobile-collapse-container" name="5">
            <template slot="title">
              <i class="fa fa-graduation-cap common-icon"></i><span class="common-text">{{ lang('Level') }}</span>
            </template>

            <div class="form-group">
              <div class="levelAreaDiv">
                <div class="">
                  <h5 class="text-left student-form__title">{{ lang('Level') }}</h5>
                </div>

                <!--                            <div class="row form-group__wrapper">-->
                <div>
                  <data-tables :data="lvlLevelList_Level">
                    <el-table-column
                      v-for="lvlLevelList_LevelAllInfo in lvlLevelList_LevelAll"
                      :prop="lvlLevelList_LevelAllInfo.prop"
                      :label="lvlLevelList_LevelAllInfo.label"
                      :key="lvlLevelList_LevelAllInfo.prop"
                      sortable="custom"
                    >
                    </el-table-column>
                  </data-tables>
                </div>
                <!--                            </div>-->
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>

      <b-tabs class="studentPageBTabs" :style="[!checkMobileStatus ? { display: 'block' } : { display: 'none' }]">
        <b-tab :title="lang('Student')" active>
          <div class="form-group">
            <div class="studentAreaDiv">
              <div class="">
                <h5 class="text-left student-form__title">{{ lang('Children Information') }}</h5>
              </div>
              <div class="row form-group__wrapper">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('First Name') }}</label>
                  <input type="text" class="form-control form__input" v-model="inputStudentFirstName" readonly="readonly" />
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Middle Name') }}</label>
                  <input type="text" class="form-control" v-model="inputStudentMiddleName" readonly="readonly" />
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Last Name') }}</label>
                  <input type="text" class="form-control" v-model="inputStudentLastName" readonly="readonly" />
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Preferred Name') }}</label>
                  <input type="text" class="form-control" v-model="inputStudentPreferredName" />
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Nationality') }}</label>
                  <input type="text" class="form-control" v-model="ddlStudentNationality" readonly="readonly" />
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Gender') }}</label>
                  <input type="text" class="form-control" v-model="ddlStudentGender" readonly="readonly" />
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Date of Birth') }}</label>
                  <div class="date">
                    <input type="text" class="form-control" v-model="inputStudentDateOfBirth" readonly="readonly" />
                  </div>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Birth Place') }}</label>
                  <input type="text" class="form-control" v-model="ddlStudentBirthPlace" readonly="readonly" />
                </div>

                <div v-if="finShowHide" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Fin') }}</label>
                  <input type="text" class="form-control" v-model="inputStudentIdentificationNo" />
                </div>

                <div v-if="finShowHide" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Fin Expiry Date') }}</label>
                  <div class="date">
                    <el-date-picker
                      v-model="inputStudentIdentificationExpiryDate"
                      format="dd/MM/yyyy"
                      value-format="dd/MM/yyyy"
                      type="date"
                      :placeholder="lang('Pick a day')"
                    ></el-date-picker>
                  </div>
                </div>

                <div v-if="birthcertShowHide" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Birth Certificate') }}</label>
                  <input type="text" class="form-control" v-model="inputStudentBirthCertificate" readonly="readonly" />
                </div>

                <div v-if="icShowHide" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('IC') }}</label>
                  <input type="text" class="form-control" v-model="inputStudentIC" readonly="readonly" />
                </div>

                <div v-if="passportShowHide" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Passport') }}</label>
                  <input type="text" class="form-control" v-model="inputStudentPassport" />
                </div>

                <div v-if="passportShowHide" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Passport Expiry Date') }}</label>
                  <div class="date">
                    <el-date-picker
                      v-model="inputStudentPassportExpiryDate"
                      format="dd/MM/yyyy"
                      value-format="dd/MM/yyyy"
                      type="date"
                      :placeholder="lang('Pick a day')"
                    ></el-date-picker>
                  </div>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Other Identification') }}</label>
                  <input type="text" class="form-control" v-model="inputStudentOtherIdentification" />
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Religion') }}</label>
                  <select v-model="ddlStudentReligion" class="form-control pro-edt-select form-control-primary">
                    <!--<option v-for="item in ddlStudentReligionList" v-bind:value="{ id: item.OPTvalue.trim(), text: item.OPTvalue.trim() }">{{ item.OPTvalue.trim() }}</option>-->
                    <option v-for="item in ddlStudentReligionList" v-bind:value="item.OPTvalue.trim()">
                      {{ lang(item.OPTvalue.trim()) }}
                    </option>
                  </select>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Additional Language') }}</label>
                  <select v-model="ddlStudentAdditionalLanguage" class="form-control pro-edt-select form-control-primary">
                    <option v-for="item in ddlStudentAdditionalLanguageList" v-bind:value="item.OPTvalue.trim()">{{ lang(item.OPTvalue.trim()) }}</option>
                  </select>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Meal Preferences') }}</label>
                  <select v-model="ddlStudentMealPreferences" class="form-control pro-edt-select form-control-primary">
                    <option v-for="item in ddlStudentMealPreferencesList" v-bind:value="item.OPTvalue.trim()">{{ lang(item.OPTvalue.trim()) }}</option>
                  </select>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Dietary Requirement') }}</label>
                  <input type="text" class="form-control" v-model="inputStudentDietaryRequirement" />
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('First Language Spoken') }}</label>
                  <input type="text" class="form-control" v-model="inputStudentFirstLanguageSpoken" />
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Second Language Spoken') }}</label>
                  <input type="text" class="form-control" v-model="inputSecondLanguageSpoken" />
                </div>

                <!--                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">-->
                <!--                                    <label>Payer</label>-->
                <!--                                    <select v-model="ddlStudentPayer"-->
                <!--                                    class="form-control pro-edt-select form-control-primary">-->
                <!--                                    <option v-for="item in ddlStudentPayerList" v-bind:value="item.OPTvalue.trim()">-->
                <!--                                    {{-->
                <!--                                    item.OPTvalue.trim() }}-->
                <!--                                    </option>-->
                <!--                                    </select>-->
                <!--                                </div>-->

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Student ID') }}</label>
                  <input type="text" class="form-control" v-model="inputStudentID" readonly="readonly" />
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" style="display: none">
                  <label>{{ lang('Membership') }}</label>
                  <select v-model="ddlStudentMembership" class="form-control pro-edt-select form-control-primary">
                    <option v-for="item in ddlStudentMembershipList" v-bind:value="item.OPTvalue.trim()">{{ item.OPTvalue.trim() }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="studentAreaDiv">
              <div class="">
                <h5 class="text-left student-form__title">{{ lang("Children's Local Residential Address") }}</h5>
              </div>

              <div class="row form-group__wrapper">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Country') }}</label>
                  <select v-model="ddlStudentLocalAddressCountry" class="form-control pro-edt-select form-control-primary">
                    <option v-for="item in countryList" v-bind:value="item.CNYname.trim()">{{ item.CNYname.trim() }}</option>
                  </select>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>* {{ lang('Postal Code') }}</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="inputStudentLocalAddressPostalCode"
                    v-on:blur="GetOneMapAPI('inputStudentLocalAddressPostalCode')"
                    :class="{ requiredFields: $v.inputStudentLocalAddressPostalCode.$error }"
                  />
                  <div class="requiredFieldsMsg" v-if="$v.inputStudentLocalAddressPostalCode.$error">
                    {{ lang('Postal code required') }}
                  </div>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>* {{ lang('Address 1') }}</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="inputStudentLocalAddress1"
                    :class="{ requiredFields: $v.inputStudentLocalAddress1.$error }"
                  />
                  <div class="requiredFieldsMsg" v-if="$v.inputStudentLocalAddress1.$error">
                    {{ lang('Address 1 required') }}
                  </div>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Address 2') }}</label>
                  <input type="text" class="form-control" v-model="inputStudentLocalAddress2" />
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Address 3') }}</label>
                  <input type="text" class="form-control" v-model="inputStudentLocalAddress3" />
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('City') }}</label>
                  <input type="text" class="form-control" v-model="inputStudentLocalAddressCity" />
                </div>
              </div>
            </div>
          </div>
        </b-tab>

        <!--                title="Emergency Contact" -->
        <b-tab :title="lang('Contact')">
          <div class="form-group">
            <div class="ecAreaDiv">
              <div class="">
                <h5 class="text-left student-form__title">{{ lang('1st Emergency Contact') }}</h5>
              </div>
              <div class="row form-group__wrapper">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Contact Person') }}</label>
                  <input type="text" class="form-control" v-model="inputStudent1stEmergencyContact" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Contact No') }}</label>
                  <input type="text" class="form-control" v-model="inputStudent1stEmergencyContactNo" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Contact Relation') }}</label>
                  <input type="text" class="form-control" v-model="inputStudent1stEmergencyContactRelation" />
                </div>
              </div>
            </div>
            <div class="ecAreaDiv">
              <div class="">
                <h5 class="text-left student-form__title">{{ lang('2nd Emergency Contact') }}</h5>
              </div>
              <div class="row form-group__wrapper">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Contact Person') }}</label>
                  <input type="text" class="form-control" v-model="inputStudent2ndEmergencyContact" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Contact No') }}</label>
                  <input type="text" class="form-control" v-model="inputStudent2ndEmergencyContactNo" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Contact Relation') }}</label>
                  <input type="text" class="form-control" v-model="inputStudent2ndEmergencyContactRelation" />
                </div>
              </div>
            </div>

            <!--                        Start Authorized Children Pickup-->
            <div class="ecAreaDiv" v-if="studentAuthorizedPickupListInt.length > 0">
              <div class="">
                <h5 class="text-left student-form__title">{{ lang('Authorized Children Pickup') }}</h5>
              </div>

              <div class="row form-group__wrapper">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div>
                    <data-tables :data="studentAuthorizedPickupListInt">
                      <el-table-column
                        v-for="studentAuthorizedPickupListInfo in studentAuthorizedPickupList"
                        :prop="studentAuthorizedPickupListInfo.prop"
                        :label="studentAuthorizedPickupListInfo.label"
                        :key="studentAuthorizedPickupListInfo.prop"
                        sortable="custom"
                      >
                      </el-table-column>
                    </data-tables>
                  </div>
                </div>

                <!--                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">-->
                <!--                                    <label>Name</label>-->
                <!--                                    <input type="text" class="form-control" v-model="inputStudentContactAuthorizedPickupName">-->
                <!--                                </div>-->
                <!--                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">-->
                <!--                                    <label>Contact No</label>-->
                <!--                                    <input type="text" class="form-control" v-model="inputStudentContactAuthorizedPickupContactNo">-->
                <!--                                </div>-->
                <!--                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">-->
                <!--                                    <label>Identify No</label>-->
                <!--                                    <input type="text" class="form-control"-->
                <!--                                           v-model="inputStudentContactAuthorizedPickupIdenNo">-->
                <!--                                </div>-->
                <!--                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">-->
                <!--                                    <label>Relationship</label>-->
                <!--                                    <input type="text" class="form-control"-->
                <!--                                           v-model="inputStudentContactAuthorizedPickupRelationship">-->
                <!--                                </div>-->
              </div>

              <!--                            <button class="btn btn-primary waves-effect waves-light m-r-10" v-on:click="addMedicationAllergiesList()">-->
              <!--                                Add-->
              <!--                            </button>-->
            </div>
            <!--                        End Authorized Children Pickup-->
          </div>
        </b-tab>

        <b-tab :title="lang('Billing')">
          <div class="form-group">
            <div class="billAreaDiv">
              <div class="">
                <h5 class="text-left student-form__title">{{ lang('Billing Info') }}</h5>
              </div>

              <div class="row form-group__wrapper">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>* {{ lang('Payer') }}</label>
                  <select v-model="ddlStudentBillingPayer" class="form-control pro-edt-select form-control-primary" disabled="disabled">
                    <!--                                        :disabled="(disFatherCompany && item.OPTvalue.trim() === 'Father Company' && divParent) || (disMotherCompany && item.OPTvalue.trim() === 'Mother Company') && divParent"-->
                    <option v-for="item in ddlStudentBillingPayerList" v-bind:value="item.OPTvalue.trim()">
                      {{ lang(item.OPTvalue.trim()) }}
                    </option>
                  </select>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Frequent Payments') }}</label>
                  <select v-model="ddlStudentBillingFrequentPayments" class="form-control pro-edt-select form-control-primary" disabled="disabled">
                    <option v-for="item in ddlStudentBillingFrequentPaymentsList" v-bind:value="item">
                      {{ item }}
                    </option>
                  </select>
                </div>

                <div v-if="isIntPreSchool || isLocalSchool" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('CDA') }}</label>
                  <input type="text" class="form-control" v-model="inputStudentBillingCda" readonly="readonly" />
                </div>

                <div v-if="ddlStudentBillingSubsidyShow" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Subsidy') }}</label>
                  <el-select v-model="ddlStudentBillingSubsidy" multiple class="ddlStudentBillingSubsidy" disabled="disabled">
                    <el-option v-for="item in ddlStudentBillingSubsidyList" :key="item.OPTid.trim()" :label="item.OPTvalue.trim()" :value="item.OPTid.trim()">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>

            <div class="billAreaDiv">
              <div class="">
                <h5 class="text-left student-form__title">{{ lang('Billing Address') }}</h5>
              </div>

              <div class="row form-group__wrapper">
                <!--                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">-->
                <!--                                    <label>Copy Address From Student's Permanent Address</label>-->
                <!--                                    <select v-model="ddlStudentBillingAddressType"-->
                <!--                                            class="form-control pro-edt-select form-control-primary">-->
                <!--                                        <option v-for="item in ddlStudentBillingAddressTypeList" v-bind:value="item">-->
                <!--                                            {{item}}-->
                <!--                                        </option>-->
                <!--                                    </select>-->
                <!--                                </div>-->

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Country') }}</label>
                  <select v-model="ddlStudentBillingAddressCountry" class="form-control pro-edt-select form-control-primary">
                    <option v-for="item in countryList" v-bind:value="item.CNYname.trim()">{{ item.CNYname.trim() }}</option>
                  </select>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>* {{ lang('Postal Code') }}</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="inputStudentBillingAddressPostalCode"
                    v-on:blur="GetOneMapAPI('inputStudentBillingAddressPostalCode')"
                    :class="{ requiredFields: $v.inputStudentBillingAddressPostalCode.$error }"
                  />
                  <div class="requiredFieldsMsg" v-if="$v.inputStudentBillingAddressPostalCode.$error">
                    {{ lang('Postal code required') }}
                  </div>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>* {{ lang('Address 1') }}</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="inputStudentBillingAddress1"
                    :class="{ requiredFields: $v.inputStudentBillingAddress1.$error }"
                  />
                  <div class="requiredFieldsMsg" v-if="$v.inputStudentBillingAddress1.$error">
                    {{ lang('Address 1 required') }}
                  </div>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Address 2') }}</label>
                  <input type="text" class="form-control" v-model="inputStudentBillingAddress2" />
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Address 3') }}</label>
                  <input type="text" class="form-control" v-model="inputStudentBillingAddress3" />
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('City') }}</label>
                  <input type="text" class="form-control" v-model="inputStudentBillingAddressCity" />
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Mobile No') }}</label>
                  <input type="text" class="form-control" v-model="inputStudentBillingMobileNo" />
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Home Tel No') }}</label>
                  <input type="text" class="form-control" v-model="inputStudentBillingHomeTelNo" />
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>* {{ lang('Email') }}</label>
                  <input type="text" class="form-control" v-model="inputStudentBillingEmail" :class="{ requiredFields: $v.inputStudentBillingEmail.$error }" />
                  <div class="requiredFieldsMsg" v-if="$v.inputStudentBillingEmail.$error">
                    {{ lang('Email required or Email invalid format') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-tab>

        <b-tab :title="lang('Medical')">
          <div class="form-group">
            <div class="medAreaDiv">
              <div class="">
                <h5 class="text-left student-form__title">{{ lang('Medication Allergies List') }}</h5>
              </div>

              <div>
                <div v-if="medicationAllergiesListInt.length > 0">
                  <data-tables :data="medicationAllergiesListInt" :action-col="medicationAllergiesListAcion">
                    <el-table-column
                      v-for="medicationAllergiesListInfo in medicationAllergiesList"
                      :prop="medicationAllergiesListInfo.prop"
                      :label="medicationAllergiesListInfo.label"
                      :key="medicationAllergiesListInfo.prop"
                      sortable="custom"
                    >
                    </el-table-column>
                  </data-tables>
                </div>
              </div>

              <div class="row form-group__wrapper">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Medication') }}</label>
                  <input type="text" class="form-control" v-model="inputStudentMedicationAllergiesMedication" />
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Remarks') }}</label>
                  <input type="text" class="form-control" v-model="inputStudentMedicationAllergiesRemarks" />
                </div>
              </div>

              <button class="btn btn-primary waves-effect waves-light m-r-10" v-on:click="addMedicationAllergiesList()">
                {{ lang('Add') }}
              </button>
            </div>

            <div class="medAreaDiv">
              <div class="">
                <h5 class="text-left student-form__title">{{ lang('Food Allergies List') }}</h5>
              </div>

              <div>
                <div v-if="foodAllergiesListInt.length > 0">
                  <data-tables :data="foodAllergiesListInt" :action-col="foodAllergiesListAcion">
                    <el-table-column
                      v-for="foodAllergiesListInfo in foodAllergiesList"
                      :prop="foodAllergiesListInfo.prop"
                      :label="foodAllergiesListInfo.label"
                      :key="foodAllergiesListInfo.prop"
                      sortable="custom"
                    >
                    </el-table-column>
                  </data-tables>
                </div>
              </div>

              <div class="row form-group__wrapper">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Food') }}</label>
                  <select v-model="ddlStudentFoodAllergiesFood" class="form-control pro-edt-select form-control-primary">
                    <option v-for="item in ddlddlStudentFoodAllergiesFoodList" v-bind:value="item.OPTvalue.trim()">{{ item.OPTvalue.trim() }}</option>
                  </select>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Remarks') }}</label>
                  <input type="text" class="form-control" v-model="inputStudentFoodAllergiesRemarks" />
                </div>
              </div>

              <button class="btn btn-primary waves-effect waves-light m-r-10" v-on:click="addFoodAllergiesList()">
                {{ lang('Add') }}
              </button>
            </div>

            <div class="medAreaDiv">
              <div class="">
                <h5 class="text-left student-form__title">{{ lang("Student's Medical Details") }}</h5>
              </div>

              <div class="row form-group__wrapper">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Major Ailments List') }}</label>
                  <textarea rows="3" class="textArea" v-model="taMajorAilmentsList"></textarea>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Name of Family Doctor') }}</label>
                  <input type="text" class="form-control" v-model="inputNameofFamilyDoctor" />
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Clinic Address') }}</label>
                  <input type="text" class="form-control" v-model="inputClinicAddress" />
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>{{ lang('Clinic Phone No') }}</label>
                  <input type="text" class="form-control" v-model="inputClinicPhoneNo" />
                </div>
              </div>
            </div>
          </div>
        </b-tab>

        <b-tab :title="lang('Level')" v-if="lvlLevelList_Level.length > 0">
          <div class="form-group">
            <div class="levelAreaDiv">
              <div class="">
                <h5 class="text-left student-form__title">{{ lang('Level') }}</h5>
              </div>

              <!--                            <div class="row form-group__wrapper">-->
              <div>
                <data-tables :data="lvlLevelList_Level">
                  <el-table-column
                    v-for="lvlLevelList_LevelAllInfo in lvlLevelList_LevelAll"
                    :prop="lvlLevelList_LevelAllInfo.prop"
                    :label="lvlLevelList_LevelAllInfo.label"
                    :key="lvlLevelList_LevelAllInfo.prop"
                    sortable="custom"
                  >
                  </el-table-column>
                </data-tables>
              </div>
              <!--                            </div>-->
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
    <br />
    <div>
      <button type="button" v-on:click="Validation" v-if="isUpdateButtonShow" class="btn btn-primary waves-effect waves-light m-r-10">
        {{ lang('Update') }}
      </button>
      <!--            <button type="button" v-on:click="Update" class="btn btn-primary waves-effect waves-light m-r-10">Update</button>-->
    </div>
    <div class="whitespace-30"></div>
  </div>
</template>
<script>
import DataSource from '../data/datasource'
import { required, requiredIf, requiredUnless, email } from 'vuelidate/lib/validators'
import ProfileImg from '../assets/boy.png'
import Cookies from 'js-cookie'
import moment from 'moment'
import { lang } from '../locale/index'

const API_HOST = process.env.VUE_APP_ROOT_API
export default {
  name: 'MyChild',
  async created() {
    if (this.$route.params.studentID === '' || this.$route.params.studentID === null || this.$route.params.studentID === undefined) {
      // window.location.replace('/MyAccount');
      window.location.replace('/newstudentinfo')
    }

    window.addEventListener('resize', this.isMobile)
  },

  destroyed() {
    window.removeEventListener('resize', this.isMobile)
  },
  async mounted() {
    this.LoadStudentInfo()
    this.BindCountryList()
    this.BindStudentDropdown()

    this.finShowHide = true
    this.birthcertShowHide = true
    this.icShowHide = true
    this.passportShowHide = true

    this.isMobile()
  },
  data() {
    return {
      studentID: '',
      imgStudentProfile: '',
      inputStudentFirstName: '',
      countryList: [],
      ddlStudentReligionList: [],
      ddlStudentAdditionalLanguageList: [],
      ddlStudentMealPreferencesList: [],
      ddlStudentMembershipList: [],
      ddlStudentResidencyStatusList: [],
      ddlStudentPayerList: [],
      ddlFatherIdentificationTypeList: [],
      ddlMotherIdentificationTypeList: [],
      ddlParentModeList: [],
      levelList: [],
      academicYearList: [],
      studentIntakeYearList: [],
      ddlChangeStatusToList: [],
      levelList_Level: [],
      academicYearList_Level: [],
      studentIntakeYearList_Level: [],

      arrayStudentIDLevelComponent: [],
      strClassIDLevelComponent: '',

      inputStudentDateOfBirth: '',
      inputFatherDateofBirth: '',
      inputStudentIdentificationExpiryDate: '',
      inputFirstCommencementDate: '',
      inputFatherIdentificationNoExpiryDate: '',
      inputMotherDateofBirth: '',
      inputMotherIdentificationNoExpiryDate: '',
      ddlStudentGender: '',
      inputStudentMiddleName: '',
      inputStudentLastName: '',
      inputStudentPreferredName: '',
      ddlStudentNationality: '',
      ddlStudentBirthPlace: '',
      inputStudentIdentificationNo: '',
      inputStudent1stEmergencyContact: '',
      inputStudent2ndEmergencyContact: '',
      inputStudent1stEmergencyContactNo: '',
      inputStudent2ndEmergencyContactNo: '',
      inputStudent1stEmergencyContactRelation: '',
      inputStudent2ndEmergencyContactRelation: '',
      inputStudentFirstLanguageSpoken: '',
      inputSecondLanguageSpoken: '',
      ddlStudentSelectLevel: '',
      ddlStudentFirstAcademicYear: '',
      inputStudentID: '',
      ddlStudentIntakeYear: '',
      inputStudentAddress1: '',
      inputStudentAddress2: '',
      inputStudentAddress3: '',
      inputStudentCity: '',
      inputStudentPostalCode: '',
      inputStudentCorrespondanceAddress1: '',
      inputStudentCorrespondanceAddress2: '',
      inputStudentCorrespondanceAddress3: '',
      inputStudentCorrespondanceCity: '',
      ddlStudentAddressCorrespondanceCountry: '',
      inputStudentCorrespondancePostalCode: '',
      inputStudentMobileNo: '',
      inputStudentOfficeTelNo: '',
      inputStudentEmail: '',
      taMajorAilmentsList: '',
      taMedicationAllergiesList: '',
      inputBloodGroup: '',
      inputBloodDonorNo: '',
      inputNameofFamilyDoctor: '',
      inputClinicAddress: '',
      inputClinicPhoneNo: '',
      inputFamilyID: '',
      inputFamilyParentID: '',
      inputFatherFirstName: '',
      inputFatherMiddleName: '',
      inputFatherLastName: '',
      inputFatherOccupation: '',
      inputFatherIdentificationNo: '',
      inputFatherMobileNo: '',
      inputFatherEmail: '',
      inputMotherFirstName: '',
      inputMotherMiddleName: '',
      inputMotherLastName: '',
      inputMotherOccupation: '',
      inputMotherIdentificationNo: '',
      inputMotherMobileNo: '',
      inputMotherEmail: '',
      inputParentAddress1: '',
      inputParentAddress2: '',
      inputParentAddress3: '',
      inputParentCity: '',
      inputParentLandlineNo: '',
      ddlParentCountry: '',
      inputParentPostalCode: '',
      ddlStudentAddressCountry: '',
      ddlStudentReligion: '',
      ddlStudentAdditionalLanguage: '',
      ddlStudentMealPreferences: '',
      ddlStudentMembership: '',
      ddlStudentResidencyStatus: '',
      ddlStudentPayer: '',
      ddlFatherIdentificationType: '',
      ddlMotherIdentificationType: '',
      ddlParentMode: '',
      inputStudentBirthCertificate: '',
      inputStudentIC: '',
      inputStudentPassport: '',
      inputStudentPassportExpiryDate: '',
      inputStudentOtherIdentification: '',
      ddlChangeStatusTo: '',
      selectedFile: null,
      ddlStudentSelectLevel_Level: '',
      ddlStudentFirstAcademicYear_Level: '',
      ddlStudentIntakeYear_Level: '',
      ddlCopyAddToResBil: '',
      ddlCopyAddToStuCorAdd: '',

      editModeDisable: '',
      lblCreateOrEdit: '',
      lblStudentID: '',
      lblParentID: '',
      lblMotherNameDuplicated: '',
      lblFatherNameDuplicated: '',
      parentAreaDiv: '',
      lblStudentIndexNo: '',
      lblCurrentStatus: '',
      finShowHide: '',
      birthcertShowHide: '',
      icShowHide: '',
      passportShowHide: '',
      stuCorAddCopy: '',
      resBilAddCopy: '',

      siblingTab: '',
      changeStatusAction: '',
      levelTab: '',

      //student medical allergies list
      medicationAllergiesListInt: [],
      medicationAllergiesList: [
        {
          prop: 'StAllItem',
          label: lang('Medication'),
        },
        {
          prop: 'StAllRemarks',
          label: lang('Remarks'),
        },
      ],
      medicationAllergiesListAcion: {
        label: lang('Delete'),
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-edit',
            },
            handler: row => {
              this.medicationAllergiesListInt.splice(this.medicationAllergiesListInt.indexOf(row), 1)
            },
            label: lang('Delete'),
          },
        ],
      },

      foodAllergiesListInt: [],
      foodAllergiesList: [
        {
          prop: 'StAllItem',
          label: lang('Food'),
        },
        {
          prop: 'StAllRemarks',
          label: lang('Remarks'),
        },
      ],
      foodAllergiesListAcion: {
        label: lang('Delete'),
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-edit',
            },
            handler: row => {
              this.foodAllergiesListInt.splice(this.foodAllergiesListInt.indexOf(row), 1)
            },
            label: lang('Delete'),
          },
        ],
      },
      ddlddlStudentFoodAllergiesFoodList: [],
      ddlStudentFoodAllergiesFood: '',
      inputStudentFoodAllergiesRemarks: '',
      inputStudentMedicationAllergiesMedication: '',
      inputStudentMedicationAllergiesRemarks: '',

      // Student - start
      inputStudentDietaryRequirement: '',
      ddlStudentLocalAddressCountry: '',
      inputStudentLocalAddressPostalCode: '',
      inputStudentLocalAddress1: '',
      inputStudentLocalAddress2: '',
      inputStudentLocalAddress3: '',
      inputStudentLocalAddressCity: '',
      // Student - end

      // Contact - start
      studentAuthorizedPickupListInt: [],
      studentAuthorizedPickupList: [
        {
          prop: 'AutPickName',
          label: lang('Name'),
        },
        {
          prop: 'AutPickIdentifyNo',
          label: lang('Identify No'),
        },
        {
          prop: 'AutPickRelationship',
          label: lang('Relationship'),
        },
        {
          prop: 'AutPickContactNo',
          label: lang('Contact No'),
        },
      ],
      // Contact - end

      // Billing - start
      ddlStudentBillingPayer: '',
      ddlStudentBillingPayerList: [],
      ddlStudentBillingFrequentPayments: '',
      ddlStudentBillingFrequentPaymentsList: ['', lang('Termly'), lang('Monthly')],
      ddlStudentBillingAddressType: '',
      ddlStudentBillingAddressTypeList: [lang('Manually Input'), lang("Student's Local Residential Address")],
      ddlStudentBillingAddressCountry: '',
      ddlStudentBillingAddressCountryList: [],
      inputStudentBillingAddressPostalCode: '',
      inputStudentBillingAddress1: '',
      inputStudentBillingAddress2: '',
      inputStudentBillingAddress3: '',
      inputStudentBillingAddressCity: '',
      inputStudentBillingMobileNo: '',
      inputStudentBillingHomeTelNo: '',
      inputStudentBillingEmail: '',
      inputStudentBillingCda: '',
      ddlStudentBillingSubsidy: [],
      ddlStudentBillingSubsidyList: [],
      ddlStudentBillingSubsidyShow: false,
      // Billing - end

      // Level - start
      lvlLevelList_Level: [],
      lvlLevelList_LevelAll: [
        {
          prop: 'CRS_Course_Name',
          label: lang('Level'),
        },
        {
          prop: 'SCH_Short_Name',
          label: lang('School Name'),
        },
        {
          prop: 'SMT_Code',
          label: lang('Academic Year Code'),
        },
        {
          prop: 'SCRS_From_Date_convert',
          label: lang('Level Start Date'),
        },
        {
          prop: 'SCRS_To_Date_convert',
          label: lang('Level End Date'),
        },
        {
          prop: 'classNameWithBatch',
          label: lang('Class'),
        },
        {
          prop: 'SCRS_Status',
          label: lang('Status'),
        },
      ],
      // Level - end

      isLocalSchool: '',
      isIntPreSchool: '',
      isIntSchool: '',
      studentSchoolID: '',
      isUpdateButtonShow: true,

      checkMobileStatus: false,
    }
  },
  methods: {
    lang,
    backPrevious() {
      this.$router.go(-1)
    },
    async uploadStudentProfileImg() {
      try {
        this.$refs.file.click()
      } catch (e) {
        this.results = e
      }
    },
    previewImgStudentProfile: function (event) {
      try {
        var input = event.target
        if (input.files && input.files[0]) {
          var reader = new FileReader()
          reader.onload = e => {
            this.imgStudentProfile = e.target.result
          }
          reader.readAsDataURL(input.files[0])
          this.selectedFile = event.target.files
        }
      } catch (e) {
        this.results = e
      }
    },
    async LoadStudentInfo() {
      try {
        let courseID
        let studentID = ''
        studentID = this.$route.params.studentID
        this.studentID = studentID
        const responce = await DataSource.shared.getStudentParentView(this.$route.params.studentID)
        if (responce) {
          if (responce.code === '88') {
            this.$notify.error({
              title: lang('Error'),
              message: lang('Error'),
            })
          } else {
            this.BindStudentFields(responce.Table)
          }
        }
        const stuProPic = await DataSource.shared.getStudentProfilePicture(this.$route.params.studentID)

        const alleRes = await DataSource.shared.getStudentAllergies(this.$route.params.studentID, '')
        if (alleRes) {
          if (alleRes.code === '88') {
            window.location.replace('/')
          } else if (alleRes.code === '99') {
            console.log('get getStudentAllergies Error')
          } else if (alleRes.code === '2') {
            console.log('getStudentAllergies No Record')
          } else {
            this.alleResLoop = alleRes.Table
            this.alleResLoop.forEach(m => {
              if (m.StAllType === 'Medical') {
                this.medicationAllergiesListInt.push(m)
              } else if (m.StAllType === 'Food') {
                this.foodAllergiesListInt.push(m)
              }
            })
          }
        }

        const resAuthorizedPickup = await DataSource.shared.getStudentAuthorizedPickup(this.$route.params.studentID)
        if (resAuthorizedPickup) {
          if (resAuthorizedPickup.code === '88') {
            window.location.replace('/')
          } else if (resAuthorizedPickup.code === '99') {
            console.log('get getStudentAuthorizedPickup Error')
          } else if (resAuthorizedPickup.code === '2') {
            console.log('getStudentAuthorizedPickup No Record')
          } else {
            this.studentAuthorizedPickupListInt = resAuthorizedPickup.Table
          }
        }

        const resStudentLvl = await DataSource.shared.getStudentLevel(this.$route.params.studentID)
        if (resStudentLvl) {
          if (resStudentLvl.code === '88') {
            window.location.replace('/')
          } else if (resStudentLvl.code === '99') {
            console.log('get getStudentLevel Error')
          } else if (resStudentLvl.code === '2') {
            console.log('getStudentLevel No Record')
          } else {
            let customLevelNotEqual = ''
            let studID = ''
            let fromDate = ''
            let toDate = ''
            this.lvlLevelList_Level = resStudentLvl.Table
            this.isUpdateButtonShow = true

            //filter the added level to BindStudentLevel
            this.GetStudentLevelListResponse = resStudentLvl.Table
            this.GetStudentLevelListResponse.forEach(m => {
              if (customLevelNotEqual === '') {
                customLevelNotEqual = m.PK_Course_ID
              } else {
                customLevelNotEqual = customLevelNotEqual + ',' + m.PK_Course_ID
              }

              if (m.SCRS_Status === 'Active') {
                courseID = m.SCRS_FK_Course_ID
                this.strClassIDLevelComponent = courseID
              }

              if (this.studentSchoolID === '') {
                if (m.CRS_Status === 'Active') {
                  this.studentSchoolID = m.CRS_FK_School_ID
                } else if (m.CRS_Status === 'Pending') {
                  if (fromDate === '') {
                    fromDate = m.CRS_Course_From_Date
                    studID = m.CRS_FK_School_ID
                  } else {
                    if (moment(m.CRS_Course_From_Date).format('DD/MM/YYYY') < moment(fromDate).format('DD/MM/YYYY')) {
                      studID = m.CRS_FK_School_ID
                    }
                  }
                } else if (m.CRS_Status === 'Closed') {
                  if (studID === '') {
                    if (toDate === '') {
                      toDate = m.CRS_Course_To_Date
                      studID = m.CRS_FK_School_ID
                    } else {
                      if (moment(m.CRS_Course_To_Date).format('DD/MM/YYYY') > moment(toDate).format('DD/MM/YYYY')) {
                        studID = m.CRS_FK_School_ID
                        this.isUpdateButtonShow = false
                      }
                    }
                  }
                }
              }
            })

            if (this.studentSchoolID === '') {
              this.studentSchoolID = studID
            }

            this.BindStudentLevel_Level(customLevelNotEqual)
            this.checkSchoolIsLocalOrInt()
            //filter the added level to BindStudentLevel
          }
        }
      } catch (e) {
        this.result = e
      }
    },
    async BindStudentFields(resultTable) {
      try {
        resultTable.forEach(m => {
          this.lblCurrentStatus = m.Status
          this.lblStudentIndexNo = m.Index_No
          this.inputStudentID = m.Index_No
          this.inputStudentFirstName = m.Full_Name
          this.inputFatherFirstName = m.PAR_Father_FirstName
          this.inputMotherFirstName = m.PAR_Mother_FirstName
          this.inputStudentMiddleName = m.Middle_name
          this.inputStudentLastName = m.Last_name
          this.ddlStudentGender = m.Sex
          this.inputStudentCorrespondanceAddress1 = m.st_corr_add_flrNo
          this.inputStudentCorrespondanceAddress2 = m.st_corr_add_blkNo
          this.inputStudentCorrespondanceCity = m.st_corr_add_stName
          this.inputStudentCorrespondancePostalCode = m.st_corr_add_pstcode
          this.inputStudentPostalCode = m.st_prm_add_pstcode
          this.inputStudentAddress1 = m.st_prm_add_blkNo
          this.inputStudentAddress2 = m.st_prm_add_flrNo
          this.inputStudentAddress3 = m.st_prm_add_BlgName
          if (m.DOB_convert !== '01/01/1901') {
            this.inputStudentDateOfBirth = m.DOB_convert
          }
          this.ddlStudentReligion = m.St_Religion
          this.ddlStudentNationality = m.Nationality
          if (m.Regst_date_convert !== '01/01/1901') {
            this.inputFirstCommencementDate = m.Regst_date_convert
          }
          this.ddlStudentAddressCountry = m.st_prm_add_country
          this.inputStudentMobileNo = m.Handphone
          this.inputStudentCorrespondanceAddress3 = m.st_corr_add_BlgName
          this.ddlStudentResidencyStatus = m.student_type
          this.ddlStudentPayer = m.sponsor_type
          this.inputStudentIdentificationNo = m.ID_Number
          this.inputStudentCity = m.st_prm_add_stName
          this.ddlStudentAddressCorrespondanceCountry = m.st_corr_add_country
          this.inputStudent2ndEmergencyContactNo = m.Fax
          this.inputStudentEmail = m.email
          this.inputStudent1stEmergencyContactNo = m.Telephone
          this.inputStudentOfficeTelNo = m.Offphone
          //this.ddlStudentSelectLevel = m.Course_Type;
          this.inputNameofFamilyDoctor = m.Family_Doctor
          this.taMajorAilmentsList = m.Ailments
          this.taMedicationAllergiesList = m.medication_allergic_to
          this.inputBloodGroup = m.BLD_grp
          this.inputBloodDonorNo = m.BLD_donor_no
          this.inputClinicAddress = m.clinic_add
          this.inputClinicPhoneNo = m.clinic_ph_no
          //this.ddlStudentFirstAcademicYear = m.Semester;
          this.inputStudentPreferredName = m.St_Preferred_Name
          this.ddlStudentAdditionalLanguage = m.St_Mother_Tongue
          this.ddlStudentMealPreferences = m.St_Meal_Preferences
          this.ddlStudentBirthPlace = m.St_Birth_Place
          this.inputStudentFirstLanguageSpoken = m.St_AdditionalLanguage
          this.inputSecondLanguageSpoken = m.St_SecondLanguageSpoken
          this.ddlStudentMembership = m.ST_StudentMemership

          this.inputStudent1stEmergencyContact = m.St_EmergencyContact
          this.inputStudent1stEmergencyContactRelation = m.St_EmergencyContactRelation
          this.inputStudent2ndEmergencyContact = m.St_2ndEmergencyContact
          this.inputStudent2ndEmergencyContactRelation = m.St_2ndEmergencyContactRelation

          if (m.ID_ExpDate_convert !== '01/01/1901') {
            this.inputStudentIdentificationExpiryDate = m.ID_ExpDate_convert
          }
          this.inputStudentBirthCertificate = m.St_BirthCer_Number
          this.inputStudentIC = m.St_IC_ID_Number
          this.inputStudentPassport = m.St_Passport_Number
          if (m.St_Passport_ExpDate_convert !== '01/01/1901') {
            this.inputStudentPassportExpiryDate = m.St_Passport_ExpDate_convert
          }
          this.inputStudentOtherIdentification = m.St_Identification_Others

          this.inputStudentDietaryRequirement = m.St_Dietary
          if (m.st_prm_add_country !== undefined && m.st_prm_add_country !== '') {
            this.ddlStudentLocalAddressCountry = m.st_prm_add_country
          } else {
            this.ddlStudentLocalAddressCountry = 'Singapore'
          }
          this.inputStudentLocalAddressPostalCode = m.st_prm_add_pstcode
          this.inputStudentLocalAddress1 = m.st_prm_add_blkNo
          this.inputStudentLocalAddress2 = m.st_prm_add_flrNo
          this.inputStudentLocalAddress3 = m.st_prm_add_BlgName
          this.inputStudentLocalAddressCity = m.st_prm_add_stName

          // check student nationality - start
          if (this.ddlStudentNationality === '' && this.ddlStudentBirthPlace === '') {
            this.finShowHide = false
            this.birthcertShowHide = false
            this.icShowHide = false
            this.passportShowHide = false
          } else if (
            (this.ddlStudentNationality === 'Singaporean' && this.ddlStudentBirthPlace === '') ||
            (this.ddlStudentNationality === '' && this.ddlStudentBirthPlace === 'Singapore') ||
            (this.ddlStudentNationality === 'Singaporean' && this.ddlStudentBirthPlace === 'Singapore')
          ) {
            this.finShowHide = false
            this.birthcertShowHide = true
            this.icShowHide = true

            if (this.ddlStudentNationality === 'Singaporean') {
              this.passportShowHide = false
            } else {
              this.passportShowHide = true
            }
          } else if (this.ddlStudentNationality !== 'Singaporean' && this.ddlStudentBirthPlace === 'Singapore') {
            this.finShowHide = true
            this.birthcertShowHide = true
            this.icShowHide = false
            this.passportShowHide = true
          } else if (this.ddlStudentNationality === 'Singaporean' && this.ddlStudentBirthPlace !== 'Singapore') {
            this.finShowHide = false
            this.birthcertShowHide = false
            this.icShowHide = true
            this.passportShowHide = false
          } else if (this.ddlStudentNationality !== 'Singaporean' && this.ddlStudentBirthPlace !== 'Singapore') {
            this.finShowHide = true
            this.birthcertShowHide = false
            this.icShowHide = false
            this.passportShowHide = true
          }
          // check student nationality - end

          // billing - start
          this.ddlStudentBillingPayer = m.sponsor_type
          this.ddlStudentBillingFrequentPayments = m.St_FrequentPayments
          if (m.st_corr_add_country !== undefined && m.st_corr_add_country !== '') {
            this.ddlStudentBillingAddressCountry = m.st_corr_add_country
          } else {
            this.ddlStudentBillingAddressCountry = 'Singapore'
          }
          this.inputStudentBillingAddressPostalCode = m.st_corr_add_pstcode
          this.inputStudentBillingAddress1 = m.st_corr_add_blkNo
          this.inputStudentBillingAddress2 = m.st_corr_add_flrNo
          this.inputStudentBillingAddress3 = m.st_corr_add_BlgName
          this.inputStudentBillingAddressCity = m.st_corr_add_stName
          this.inputStudentBillingMobileNo = m.Handphone
          this.inputStudentBillingHomeTelNo = m.Offphone
          this.inputStudentBillingEmail = m.email
          this.inputStudentBillingCda = m.St_Cda
          if (m.Nationality === 'Singaporean') {
            this.ddlStudentBillingSubsidyShow = true
            this.ddlStudentBillingSubsidy.push.apply(this.ddlStudentBillingSubsidy, m.St_Subsidy.split(','))
          } else {
            this.ddlStudentBillingSubsidy = []
            this.ddlStudentBillingSubsidyShow = false
          }
          // billing - end
        })
      } catch (e) {
        this.results = e
      }
    },
    async BindCountryList() {
      try {
        const response = await DataSource.shared.getCountryList()
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.countryListResponse = response.Table
            this.countryListResponse.forEach(m => {
              this.countryList.push(m)
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async BindStudentDropdown() {
      try {
        let jsonString = '"Religion":"Religion"'
        jsonString = jsonString + ',"Mother Tongue":"Mother Tongue"'
        jsonString = jsonString + ',"Meal Preferences":"Meal Preferences"'
        jsonString = jsonString + ',"Student Membership":"Student Membership"'
        jsonString = jsonString + ',"Residency Status":"Residency Status"'
        jsonString = jsonString + ',"Sponsorship Type":"Sponsorship Type"'
        jsonString = jsonString + ',"ParentID":"ParentID"'
        jsonString = jsonString + ',"Food Allergies":"Food Allergies"'
        jsonString = jsonString + ',"Parent Mode":"Parent Mode"'

        jsonString = jsonString + ',"Subsidies":"Subsidies"'
        jsonString = '{' + jsonString + '}'

        const response = await DataSource.shared.getStudentDropDownList(jsonString)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.studentDropDownListResponse = response.Table
            this.studentDropDownListResponse.forEach(m => {
              if (m.OGPname.trim() === 'Religion') {
                this.ddlStudentReligionList.push(m)
              } else if (m.OGPname.trim() === 'Mother Tongue') {
                this.ddlStudentAdditionalLanguageList.push(m)
              } else if (m.OGPname.trim() === 'Meal Preferences') {
                this.ddlStudentMealPreferencesList.push(m)
              } else if (m.OGPname.trim() === 'Student Membership') {
                this.ddlStudentMembershipList.push(m)
              } else if (m.OGPname.trim() === 'Residency Status') {
                this.ddlStudentResidencyStatusList.push(m)
              } else if (m.OGPname.trim() === 'Sponsorship Type') {
                this.ddlStudentPayerList.push(m)
                this.ddlStudentBillingPayerList.push(m)
              } else if (m.OGPname.trim() === 'ParentID') {
                this.ddlFatherIdentificationTypeList.push(m)
                this.ddlMotherIdentificationTypeList.push(m)
              } else if (m.OGPname.trim() === 'Food Allergies') {
                this.ddlddlStudentFoodAllergiesFoodList.push(m)
              } else if (m.OGPname.trim() === 'Parent Mode') {
                this.ddlParentModeList.push(m)
              } else if (m.OGPname.trim() === 'Subsidies') {
                this.ddlStudentBillingSubsidyList.push(m)
              }
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async Validation() {
      try {
        this.$v.$touch()
        if (this.$v.$error) {
          this.$notify.error({
            title: lang('Error'),
            message: lang('Please fill in all * fields & at least one of ** field'),
          })
          return
        }
        this.Update()
      } catch (e) {
        this.results = e
      }
    },
    async Update() {
      try {
        //students
        let jsonString = '"Full_Name":"' + this.inputStudentFirstName + '"'
        jsonString = jsonString + ',"Middle_name":"' + this.inputStudentMiddleName + '"'
        jsonString = jsonString + ',"Last_name":"' + this.inputStudentLastName + '"'
        jsonString = jsonString + ',"Sex":"' + this.ddlStudentGender + '"'
        jsonString = jsonString + ',"st_corr_add_flrNo":"' + this.inputStudentCorrespondanceAddress1 + '"'
        jsonString = jsonString + ',"st_corr_add_blkNo":"' + this.inputStudentCorrespondanceAddress2 + '"'
        jsonString = jsonString + ',"st_corr_add_stName":"' + this.inputStudentCorrespondanceCity + '"'
        jsonString = jsonString + ',"st_corr_add_pstcode":"' + this.inputStudentCorrespondancePostalCode + '"'
        jsonString = jsonString + ',"st_prm_add_pstcode":"' + this.inputStudentPostalCode + '"'
        jsonString = jsonString + ',"st_prm_add_blkNo":"' + this.inputStudentAddress1 + '"'
        jsonString = jsonString + ',"st_prm_add_flrNo":"' + this.inputStudentAddress2 + '"'
        jsonString = jsonString + ',"st_prm_add_BlgName":"' + this.inputStudentAddress3 + '"'
        jsonString = jsonString + ',"DOB":"' + this.inputStudentDateOfBirth + '"'
        jsonString = jsonString + ',"St_Religion":"' + this.ddlStudentReligion + '"'
        jsonString = jsonString + ',"Nationality":"' + this.ddlStudentNationality + '"'
        jsonString = jsonString + ',"Regst_date":"' + this.inputFirstCommencementDate + '"'
        jsonString = jsonString + ',"st_prm_add_country":"' + this.ddlStudentAddressCountry + '"'
        jsonString = jsonString + ',"Handphone":"' + this.inputStudentMobileNo + '"'
        jsonString = jsonString + ',"st_corr_add_BlgName":"' + this.inputStudentCorrespondanceAddress3 + '"'
        jsonString = jsonString + ',"student_type":"' + this.ddlStudentResidencyStatus + '"'
        jsonString = jsonString + ',"sponsor_type":"' + this.ddlStudentPayer + '"'
        jsonString = jsonString + ',"ID_Number":"' + this.inputStudentIdentificationNo + '"'
        jsonString = jsonString + ',"st_prm_add_stName":"' + this.inputStudentCity + '"'
        jsonString = jsonString + ',"st_corr_add_country":"' + this.ddlStudentAddressCorrespondanceCountry + '"'
        jsonString = jsonString + ',"Fax":"' + this.inputStudent2ndEmergencyContactNo + '"'
        jsonString = jsonString + ',"email":"' + this.inputStudentEmail + '"'
        jsonString = jsonString + ',"Telephone":"' + this.inputStudent1stEmergencyContactNo + '"'
        jsonString = jsonString + ',"Offphone":"' + this.inputStudentOfficeTelNo + '"'
        jsonString = jsonString + ',"Family_Doctor":"' + this.inputNameofFamilyDoctor + '"'
        jsonString = jsonString + ',"Ailments":"' + this.taMajorAilmentsList + '"'
        jsonString = jsonString + ',"medication_allergic_to":"' + this.taMedicationAllergiesList + '"'
        jsonString = jsonString + ',"BLD_grp":"' + this.inputBloodGroup + '"'
        jsonString = jsonString + ',"BLD_donor_no":"' + this.inputBloodDonorNo + '"'
        jsonString = jsonString + ',"clinic_add":"' + this.inputClinicAddress + '"'
        jsonString = jsonString + ',"clinic_ph_no":"' + this.inputClinicPhoneNo + '"'
        jsonString = jsonString + ',"St_Preferred_Name":"' + this.inputStudentPreferredName + '"'
        jsonString = jsonString + ',"St_Mother_Tongue":"' + this.ddlStudentAdditionalLanguage + '"'
        jsonString = jsonString + ',"St_Meal_Preferences":"' + this.ddlStudentMealPreferences + '"'
        jsonString = jsonString + ',"St_Birth_Place":"' + this.ddlStudentBirthPlace + '"'
        jsonString = jsonString + ',"St_AdditionalLanguage":"' + this.inputStudentFirstLanguageSpoken + '"'
        jsonString = jsonString + ',"St_SecondLanguageSpoken":"' + this.inputSecondLanguageSpoken + '"'
        jsonString = jsonString + ',"ST_StudentMemership":"' + this.ddlStudentMembership + '"'
        jsonString = jsonString + ',"ID_ExpDate":"' + this.inputStudentIdentificationExpiryDate + '"'
        jsonString = jsonString + ',"St_BirthCer_Number":"' + this.inputStudentBirthCertificate + '"'
        jsonString = jsonString + ',"St_IC_ID_Number":"' + this.inputStudentIC + '"'
        jsonString = jsonString + ',"St_Passport_Number":"' + this.inputStudentPassport + '"'
        jsonString = jsonString + ',"St_Passport_ExpDate":"' + this.inputStudentPassportExpiryDate + '"'
        jsonString = jsonString + ',"St_Identification_Others":"' + this.inputStudentOtherIdentification + '"'

        jsonString = jsonString + ',"St_EmergencyContact":"' + this.inputStudent1stEmergencyContact + '"'
        jsonString = jsonString + ',"St_EmergencyContactRelation":"' + this.inputStudent1stEmergencyContactRelation + '"'
        jsonString = jsonString + ',"St_2ndEmergencyContact":"' + this.inputStudent2ndEmergencyContact + '"'
        jsonString = jsonString + ',"St_2ndEmergencyContactRelation":"' + this.inputStudent2ndEmergencyContactRelation + '"'
        //students

        // student
        jsonString = jsonString + ',"St_Dietary":"' + this.inputStudentDietaryRequirement + '"'
        jsonString = jsonString + ',"st_prm_add_country":"' + this.ddlStudentLocalAddressCountry + '"'
        jsonString = jsonString + ',"st_prm_add_pstcode":"' + this.inputStudentLocalAddressPostalCode + '"'
        jsonString = jsonString + ',"st_prm_add_blkNo":"' + this.inputStudentLocalAddress1 + '"'
        jsonString = jsonString + ',"st_prm_add_flrNo":"' + this.inputStudentLocalAddress2 + '"'
        jsonString = jsonString + ',"st_prm_add_BlgName":"' + this.inputStudentLocalAddress3 + '"'
        jsonString = jsonString + ',"st_prm_add_stName":"' + this.inputStudentLocalAddressCity + '"'
        // student
        //
        // // billing - start
        jsonString = jsonString + ',"sponsor_type":"' + this.ddlStudentBillingPayer + '"'
        jsonString = jsonString + ',"St_FrequentPayments":"' + this.ddlStudentBillingFrequentPayments + '"'
        // let subsidyList = '';
        // this.ddlStudentBillingSubsidy.forEach(optid => {
        //     if (subsidyList === '') {
        //         subsidyList = optid;
        //     } else {
        //         subsidyList += ',' + optid;
        //     }
        // });
        // jsonString = jsonString + ',"St_Subsidy":"' + subsidyList + '"';
        jsonString = jsonString + ',"st_corr_add_country":"' + this.ddlStudentBillingAddressCountry + '"'
        jsonString = jsonString + ',"st_corr_add_pstcode":"' + this.inputStudentBillingAddressPostalCode + '"'
        jsonString = jsonString + ',"st_corr_add_blkNo":"' + this.inputStudentBillingAddress1 + '"'
        jsonString = jsonString + ',"st_corr_add_flrNo":"' + this.inputStudentBillingAddress2 + '"'
        jsonString = jsonString + ',"st_corr_add_BlgName":"' + this.inputStudentBillingAddress3 + '"'
        jsonString = jsonString + ',"st_corr_add_stName":"' + this.inputStudentBillingAddressCity + '"'
        jsonString = jsonString + ',"Handphone":"' + this.inputStudentBillingMobileNo + '"'
        jsonString = jsonString + ',"Offphone":"' + this.inputStudentBillingHomeTelNo + '"'
        jsonString = jsonString + ',"email":"' + this.inputStudentBillingEmail + '"'
        // // billing - end

        jsonString = '[{ ' + jsonString + ' }]'
        //allergies list combining into one whole list//
        let allergiesList = []

        //medical
        this.medicationAllergiesListInt.forEach(item => {
          let medicationAllergiesListIntDetials = {
            Item: item.StAllItem,
            Remarks: item.StAllRemarks,
            Type: 'Medical',
          }

          allergiesList.push(medicationAllergiesListIntDetials)
        })

        //food
        this.foodAllergiesListInt.forEach(item => {
          let foodAllergiesListIntDetials = {
            Item: item.StAllItem,
            Remarks: item.StAllRemarks,
            Type: 'Food',
          }

          allergiesList.push(foodAllergiesListIntDetials)
        })
        //allergies list combining into one whole list//

        let authorizedPickupList = []

        const saveStuRes = await DataSource.shared.updateStudent(
          this.selectedFile,
          this.studentID,
          jsonString,
          JSON.stringify(allergiesList),
          JSON.stringify(authorizedPickupList),
        )
        if (saveStuRes) {
          if (saveStuRes.code === '88') {
            // window.location.replace('/');
          } else if (saveStuRes.code === '1') {
            this.$notify({
              title: lang('Success'),
              message: lang('Records Successfully Saved'),
              type: 'success',
            })
            // window.location.replace('/MyAccount');
          } else {
            this.$notify.error({
              title: lang('Error'),
              message: lang('Update Error - Please try again later'),
            })
            // window.location.replace('/MyAccount');
          }
        }
      } catch (e) {}
    },
    addMedicationAllergiesList() {
      if (this.inputStudentMedicationAllergiesMedication !== '' && this.inputStudentMedicationAllergiesRemarks !== '') {
        let addNewRowList = {
          StAllItem: this.inputStudentMedicationAllergiesMedication,
          StAllRemarks: this.inputStudentMedicationAllergiesRemarks,
        }

        this.medicationAllergiesListInt.push(addNewRowList)

        this.inputStudentMedicationAllergiesMedication = ''
        this.inputStudentMedicationAllergiesRemarks = ''
      } else {
        alert(lang('Please fill Medication and Remarks'))
      }
    },
    addFoodAllergiesList() {
      if (this.ddlStudentFoodAllergiesFood !== '' && this.inputStudentFoodAllergiesRemarks !== '') {
        let addNewRowList = {
          StAllItem: this.ddlStudentFoodAllergiesFood,
          StAllRemarks: this.inputStudentFoodAllergiesRemarks,
        }

        this.foodAllergiesListInt.push(addNewRowList)

        this.ddlStudentFoodAllergiesFood = ''
        this.inputStudentFoodAllergiesRemarks = ''
      } else {
        alert(lang('Please fill Food and Remarks'))
      }
    },

    async BindStudentLevel_Level(customLevelNotEqual) {
      try {
        let courseID
        const response = await DataSource.shared.getLevel(customLevelNotEqual)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.levelListResponse = response.Table
            //console.log(this.levelListResponse,"222");
            this.levelListResponse.forEach(m => {
              this.levelList_Level.push(m)
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    async GetOneMapAPI(postcodeModel) {
      try {
        if (
          postcodeModel === 'inputStudentLocalAddressPostalCode' &&
          this.inputStudentLocalAddressPostalCode !== '' /*&& this.inputStudentLocalAddress1 === ''*/
        ) {
          if (this.ddlStudentLocalAddressCountry === 'Singapore') {
            //to take out S in front of postcode
            let postcode = this.inputStudentLocalAddressPostalCode
            if (postcode.substring(0, 1).toUpperCase() === 'S') {
              postcode = postcode.substring(1, postcode.length)
            }
            //to take out S in front of postcode

            const response = await DataSource.shared.oneMapCommonApiSearchVal(postcode)
            if (response.found > 0) {
              this.inputStudentLocalAddress1 = response.results[0].BLK_NO.trim() + ' ' + response.results[0].ROAD_NAME.trim()
            }
          }
        } else if (
          postcodeModel === 'inputStudentBillingAddressPostalCode' &&
          this.inputStudentBillingAddressPostalCode !== '' /*&& this.inputStudentBillingAddress1 === ''*/
        ) {
          if (this.ddlStudentBillingAddressCountry === 'Singapore') {
            //to take out S in front of postcode
            let postcode = this.inputStudentBillingAddressPostalCode
            if (postcode.substring(0, 1).toUpperCase() === 'S') {
              postcode = postcode.substring(1, postcode.length)
            }
            //to take out S in front of postcode

            const response = await DataSource.shared.oneMapCommonApiSearchVal(postcode)
            if (response.found > 0) {
              this.inputStudentBillingAddress1 = response.results[0].BLK_NO.trim() + ' ' + response.results[0].ROAD_NAME.trim()
            }
          }
        }

        // this.onchangeCopyAdd();
      } catch (e) {
        this.results = e
      }
    },

    async checkSchoolIsLocalOrInt() {
      try {
        const response = await DataSource.shared.getSchoolInfoBySchoolID(this.studentSchoolID)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('no school found in getSchoolInfoBySchoolID')
          } else {
            if (response.Table[0].SCH_SchoolType === 'International') {
              this.isIntSchool = true
            } else if (response.Table[0].SCH_SchoolType === 'International Pre-School') {
              this.isIntPreSchool = true
            } else {
              this.isLocalSchool = true
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    isMobile() {
      let screenWidth = window.innerWidth
      if (screenWidth <= 770) {
        this.checkMobileStatus = true
        // return true;
      } else {
        this.checkMobileStatus = false
        // return false;
      }
    },
  },
  validations: {
    // student
    inputStudentLocalAddressPostalCode: { required },
    inputStudentLocalAddress1: { required },

    // billing
    inputStudentBillingEmail: { required, email },
    inputStudentBillingAddressPostalCode: { required },
    inputStudentBillingAddress1: { required },
  },
}
</script>
<style scoped>
.studentPageBTabs {
  position: relative;
}
.alert-badge {
  background: red;
  width: 14px;
  height: 14px;
  text-align: center;
  display: block;
  border-radius: 50%;
  font-weight: bold;
  color: #fff;
  position: absolute;
  top: 3px;
  line-height: 1.2;
  font-size: 12px;
}

.badge1 {
  left: 83px;
}

.badge2 {
  left: 185px;
}

.badge4 {
  left: 503px;
}
.studentAreaDiv,
.familyIDAreaDiv,
.parentAreaDiv,
.amAreaDiv,
.ecAreaDiv {
}

.btnFamilyIDSearch {
  margin-top: 10px;
}

.el-date-editor,
.el-input {
  width: 100% !important;
}

.requiredFields {
  border-color: #f79483;
}

.requiredFieldsMsg {
  color: red;
  font-weight: bold;
}

.buttonArea {
  margin: 20px 0 0 0;
}

.buttonArea .btn-primary {
  margin: 0 0 0 20px;
}

.btn-primary {
  display: inline;
}

.modeArea {
  text-align: left;
}

.textArea {
  width: 100%;
  resize: none;
}

::-webkit-scrollbar-track {
  background-color: whitesmoke;
}

.lblSearchFamily {
  width: 100%;
}

.siblingNoRecordArea {
  padding: 20px;
}

.changeStatusArea {
  background-color: white;
  text-align: left;
  padding: 0px;
}

.ddlChangeStatusTo,
.lblChangeStatusTo,
.btnChangeStatus {
  width: auto;
  display: inline !important;
  margin: 10px;
}

.imgStudentProfile:hover {
  cursor: pointer;
}

.imgStudentProfile {
  /*width: 300px;*/
  /*height: 300px;*/
  width: 200px;
  height: auto;
  border-radius: 100%;
  background-color: #ffffff;
  margin-top: 16px;
}

.profilePictureArea {
  text-align: left;
  position: relative;
}

.familyIDAreaDiv button {
  margin-bottom: 20px;
}

.profile_wrap span {
  font-size: 20px;
  margin-left: auto;
  letter-spacing: 7px;
  text-transform: uppercase;
}

.profile_wrap {
  display: flex;
  align-items: center;
  position: relative;
}
.profilePictureArea:before {
  content: '';
  background: white;
  display: block;
  height: 69%;
  position: absolute;
  width: 100%;
  top: -10px;
}

.fa-clone {
  font-size: 30px;
  border-radius: 40%;
  padding: 10px;
  background-color: #4caf50;
  cursor: pointer;
}

.fa-clone:hover {
  background-color: #5fb962;
}

.ttStuCorAddCopy {
  text-align: left;
}

.ttStuCorAddCopy .ttnStuCorAddCopy {
  visibility: hidden;
  width: auto;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 5px;
  padding: 5px;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.ttStuCorAddCopy:hover .ttnStuCorAddCopy {
  visibility: visible;
}

.billAreaDiv,
.levelAreaDiv {
  width: auto;
  padding: 20px;
}

.billAreaDiv label,
.levelAreaDiv label {
  color: #666;
  font-weight: normal;
}

.ddlStudentBillingSubsidy {
  width: 100%;
}

/*  Mobile Css  */
.mobile-myChild .datatable-edit__header {
  text-align: center;
  border-radius: 4px 4px 0px 0px;
  padding: 10px 0px;
  margin: 0px;
  background: #3c3956;
}

.mobile-back {
  position: absolute;
  left: 15px;
}

.mobile-myChild .profilePictureArea {
  padding: 0px !important;
  padding: 5px;
}

.mobile-myChild .profilePictureArea .container .profile_wrap > span {
  font-size: 12px;
}

.mobile-collapse-container {
  border-bottom: 1px solid #ccc;
}

.common-icon {
  color: dodgerblue;
  padding: 5px;
  background: #f7f7f7;
  border-radius: 50%;
  width: 30px;
  margin-right: 15px;
}

.common-text {
  font-size: 12px;
}
</style>

<style>
.studentPageBTabs .tab-content {
  margin-top: 30px;
}

.studentPageBTabs .nav-link {
  font-weight: bold;
}

.studentPageBTabs .nav-tabs .nav-link.active {
  background-color: #413f56;
  color: white;
  border: 5px solid #dee2e6;
}

.studentPageBTabs .nav-tabs {
  border-bottom: 5px solid #dee2e6;
}

.studentPageBTabs .nav-tabs .nav-item {
  flex: 1;
}

/* Mobile Css */
.mobile-studentPageBTabs .el-collapse-item__header {
  background: #edf0f4;
}
</style>
